import css from './delta.module.scss';
import OverView from './components/OverView';
import { intlNumber } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/componentsH5/ProductComponents';
import UseTime from '@/componentsH5/ProductDelta/deltamaxnew/components/useTime';
import { BannerModule, TextWithImage, TextBanner } from '@/componentsH5/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import {
    EF50TVH5,
    EFAirConditionerH5,
    EFBlenderH5,
    EFCameraH5,
    EFCarFridgeH5,
    EFCircularSawH5,
    EFCoffeeH5,
    EFCuttingH5,
    EFDrillH5,
    EFDroneH5,
    EFFryerH5,
    EFGrillH5,
    EFHammerH5,
    EFLapTopH5,
    EFLightH5,
    EFMicrowaveH5,
    EFOvenH5,
    EFPhoneH5,
    EFProjectorH5,
    EFPS5H5,
    EFRefrigeratorH5,
    EFSpeakerH5,
} from '@/components/UI/svg/ProductStatic';
import { getImageLocal } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';

export default function Delta() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const imageLocal = getImageLocal(locale, ['jp', 'de', 'cn']);
    const { t } = useLang('delta_new');
    const webpUrl = '/media/delta/h5/';
    const banner_items = [
        {
            bgImgs: ['delta_banner_h5.webp', 'delta_banner_h5.jpg'],
            title: t('DELTA'),
            des: t('banner'),
        },
    ];

    const textData = {
        title: t('capacity'),
        synopsis: t('capacity_sub_title'),
        desc: t('capacity_desc'),
        phrase: t('capacity_notice'),
    };
    const product: any = {
        us: ['product_ps_delta_delta_mini', 'product_ps_delta_delta_max'],
        cn: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        za: ['product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
    };
    const otherProduct = getDetaileMoreProducts(gloproductlist, product[locale] || product.us);

    const textWithImgItem1 = {
        title: t('AC_output'),
        synopsis: t.raw('AC_output_sub_title'),
        desc: t.raw('AC_output_desc'),
        phrase: t('AC_output_notice'),
        img_url: ['delta4_h5.webp', 'delta4_h5.jpg'],
    };

    const textWithImgItem2 = {
        title: '',
        icon: ['delta5_h5.webp', 'delta5_h5.png'],
        synopsis: t.raw('charging_faster_h5'),
        desc: t.raw('charging_faster_desc_h5'),
        notice: t('charging_faster_notice'),
        img_url: [`delta6_h5_${imageLocal}.webp`, `delta6_h5_${imageLocal}.jpg`],
        newWindLink: '/x-stream',
        linkDesc: t('x_stream_link'),
        arr: [
            {
                num: intlNumber(locale, 3.5),
                eum: t('Hrs'),
                desc: t('charging_faster_desc2'),
            },
            {
                num: intlNumber(locale, 1.6),
                eum: t('Hrs'),
                desc: t('charging_faster_desc3'),
            },
        ],
    };

    const textWithImgItem3 = {
        title: '',
        synopsis: t('caught_in_dark'),
        desc: t('caught_in_dark_desc'),
        phrase: t('caught_in_dark_notice'),
        img_url: ['delta7_h5.webp', 'delta7_h5.png'],
    };

    const textWithImgItem4 = {
        title: '',
        synopsis: t('pure_power'),
        desc: t('pure_power_desc'),
        img_url: ['delta8_h5.webp', 'delta8_h5.png'],
    };

    const applicationsUseTime: any = [
        {
            key: 0,
            title: t('home_backup'),
            img: '/media/delta/h5/useTime/delta-max01.png',
            content: [
                {
                    icon: <EFLightH5 />,
                    device: 'Light',
                    usageTime: [{ time: 30, unit: t('Hrs') }],
                },
                {
                    icon: <EFRefrigeratorH5 />,
                    device: 'Refrigerator',
                    usageTime: [{ time: `${intlNumber(locale, 6.3)}-${intlNumber(locale, 12.6)}`, unit: t('Hrs') }],
                },
                {
                    icon: '/media/delta/h5/useTime/homeBc05.svg',
                    device: 'Washer',
                    usageTime: [{ time: intlNumber(locale, 2.1), unit: t('Hrs') }],
                },
                {
                    icon: '/media/delta/h5/useTime/homeBc06.svg',
                    device: 'Electric Frying Pan',
                    usageTime: [
                        {
                            time: intlNumber(locale, 0.9),
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EFMicrowaveH5 />,
                    device: 'Microwave',
                    usageTime: [
                        {
                            time: intlNumber(locale, 0.9),
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EF50TVH5 />,
                    device: '50" TV',
                    usageTime: [{ time: 13, unit: t('Hrs') }],
                },
                {
                    icon: '/media/delta/h5/useTime/hair-dryer-icon.svg',
                    device: 'Hair Dryer',
                    usageTime: [
                        {
                            time: intlNumber(locale, 0.7),
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EFCoffeeH5 />,
                    device: 'Coffee Maker',
                    usageTime: [{ time: intlNumber(locale, 1.1), unit: t('Hrs') }],
                },
                {
                    icon: <EFCoffeeH5 />,
                    device: 'Coffee Maker',
                    usageTime: [{ time: intlNumber(locale, 1.1), unit: t('Hrs') }],
                },
            ],
        },
        {
            key: 1,
            title: t('off_life'),
            img: '/media/delta/h5/useTime/delta-max02.png',
            content: [
                {
                    icon: <EFPhoneH5 />,
                    device: 'Phone',
                    usageTime: [{ time: 104, unit: locale === 'sa' ? t('Times1') : t('Times') }],
                },
                {
                    icon: <EFLapTopH5 />,
                    device: 'Laptop',
                    usageTime: [{ time: 19, unit: locale === 'sa' ? t('Times1') : t('Times') }],
                },
                {
                    icon: <EFCameraH5 />,
                    device: 'Camera',
                    usageTime: [{ time: 70, unit: locale === 'sa' ? t('Times1') : t('Times') }],
                },
                {
                    icon: <EFDroneH5 />,
                    device: 'Drone',
                    usageTime: [{ time: 29, unit: locale === 'sa' ? t('Times1') : t('Times') }],
                },
                {
                    icon: <EFSpeakerH5 />,
                    device: 'Speaker',
                    usageTime: [{ time: 36, unit: t('Hrs') }],
                },
                {
                    icon: <EFBlenderH5 />,
                    device: 'Blender',
                    usageTime: [{ time: intlNumber(locale, 2.1), unit: t('Hrs') }],
                },
                {
                    icon: <EFCarFridgeH5 />,
                    device: 'Car Fridge',
                    usageTime: [{ time: '19-38', unit: t('Hrs') }],
                },
                {
                    icon: <EFProjectorH5 />,
                    device: 'Projector',
                    usageTime: [{ time: 13, unit: t('Hrs') }],
                },
                {
                    icon: <EFPS5H5 />,
                    device: 'PS5',
                    usageTime: [{ time: intlNumber(locale, 2.1), unit: t('Hrs') }],
                },
                {
                    icon: <EFPS5H5 />,
                    device: 'PS5',
                    usageTime: [{ time: intlNumber(locale, 2.1), unit: t('Hrs') }],
                },
            ],
        },
        {
            key: 2,
            title: t('professional'),
            img: '/media/delta/h5/useTime/delta-max03.png',
            content: [
                {
                    icon: <EFCircularSawH5 />,
                    device: 'Circular Saw',
                    usageTime: [
                        {
                            time: intlNumber(locale, 0.8),
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EFAirConditionerH5 />,
                    device: 'Air Conditioner',
                    usageTime: [{ time: `${intlNumber(locale, 0.6)}-${intlNumber(locale, 1.2)}`, unit: t('Hrs') }],
                },
                {
                    icon: <EFHammerH5 />,
                    device: 'Electric Hammer',
                    usageTime: [
                        {
                            time: intlNumber(locale, 0.9),
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EFDrillH5 />,
                    device: 'Electric Drill',
                    usageTime: [
                        {
                            time: 1,
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EFCuttingH5 />,
                    device: 'Cutting Machine',
                    usageTime: [
                        {
                            time: 1,
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EFOvenH5 />,
                    device: 'Electric Oven',
                    usageTime: [
                        {
                            time: intlNumber(locale, 0.7),
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EFGrillH5 />,
                    device: 'Electric Grill',
                    usageTime: [
                        {
                            time: intlNumber(locale, 0.9),
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EFFryerH5 />,
                    device: 'Air Fryer',
                    usageTime: [
                        {
                            time: intlNumber(locale, 0.7),
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
                {
                    icon: <EFFryerH5 />,
                    device: 'Air Fryer',
                    usageTime: [
                        {
                            time: intlNumber(locale, 0.7),
                            unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                        },
                    ],
                },
            ],
        },
    ];
    return (
        <div className={`${css.delta}`}>
            <div style={{ width: '100%' }}>
                <BannerModule
                    config={{
                        position: 'top',
                        theme: 'white',
                        webpUrl,
                    }}
                    data={banner_items}
                />
            </div>
            <LineSpace height={0.3} background="#000" />
            {/* 新版本一图看懂 */}
            <OverView />
            <LineSpace height={1.2} background="#000" />
            <div style={{ width: '2.85rem', margin: '0 auto' }}>
                <TextBanner
                    config={{
                        text: 'left',
                        titleColor: '#fff',
                        synopsisColor: '#fff',
                        descColor: '#919191',
                        phraseColor: '#666',
                    }}
                    data={textData}
                />
            </div>
            <LineSpace height={0.4} background="#000" />
            <div className="application-wrapper">
                <UseTime timeList={applicationsUseTime} langKey="delta_new" />
            </div>
            <LineSpace height={1.2} background="#000" />
            <TextWithImage
                config={{
                    position: 'top',
                    text: 'left',
                    descColor: '#919191',
                    phraseColor: 'rgb(102,102,102)',
                    titleColor: '#fff',
                    synopsisColor: '#fff',
                    webpUrl,
                }}
                data={textWithImgItem1}
            />

            <LineSpace height={0.8} background="#000" />
            <div className="textWithImage1">
                <TextWithImage
                    config={{
                        position: 'top',
                        text: 'left',
                        descColor: '#919191',
                        titleColor: '#fff',
                        synopsisColor: '#fff',
                        iconWidth: '1rem',
                        iconHeight: '0.29rem',
                        itemsColor: '#fff',
                        itemsDescColor: '#919191',
                        phraseColor: 'rgb(102,102,102)',
                        webpUrl,
                    }}
                    data={textWithImgItem2}
                />
            </div>
            <LineSpace height={1.2} background="#000" />
            <TextWithImage
                config={{
                    position: 'top',
                    text: 'left',
                    descColor: '#919191',
                    titleColor: '#fff',
                    synopsisColor: '#fff',
                    phraseColor: 'rgb(102,102,102)',
                    fullScreen: false,
                    webpUrl,
                }}
                data={textWithImgItem3}
            />
            <LineSpace height={1.2} background="#000" />
            <TextWithImage
                config={{
                    position: 'top',
                    text: 'left',
                    descColor: '#919191',
                    titleColor: '#fff',
                    synopsisColor: '#fff',
                    phraseColor: 'rgb(102,102,102)',
                    fullScreen: false,
                    webpUrl,
                }}
                data={textWithImgItem4}
            />
            <LineSpace height={1.2} background="#000" />
            <div className="container">
                <OtherList theme="black" data={otherProduct} />
            </div>
        </div>
    );
}
